import React, { useState } from 'react';
import { UserCircleIcon, SpinnerIcon } from '../../../components/Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../constants';

interface RegisterStepEmailProps {
  email: string;
  setEmail: (val: string) => void;
  onNext: () => void;
  onEmailExists: (msg: string) => void;
  onSwitchToSignIn: () => void;
  isLoading: boolean;
}

export const RegisterStepEmail: React.FC<RegisterStepEmailProps> = ({
  email,
  setEmail,
  onNext,
  onEmailExists,
  onSwitchToSignIn,
  isLoading,
}) => {
  const [checking, setChecking] = useState(false);

  const handleValidateEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail || checking || isLoading) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(cleanEmail)) {
      onEmailExists('Por favor ingresa un formato de correo válido.');
      return;
    }

    setChecking(true);
    try {
      const res = await fetch('/api/auth/check-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: cleanEmail }),
      });
      const data = await res.json();
      if (data.exists) {
        onEmailExists('El correo electrónico ya se encuentra registrado. Por favor inicia sesión.');
      } else {
        onNext();
      }
    } catch (err: any) {
      onEmailExists(err?.message || 'Error al verificar disponibilidad del correo.');
    } finally {
      setChecking(false);
    }
  };

  const isBusy = checking || isLoading;

  return (
    <form onSubmit={handleValidateEmail} className="space-y-4">
      <div className="text-center pb-1">
        <p className="text-xs text-gray-500 font-medium">
          Paso 1 de 2: Valida tu correo electrónico
        </p>
      </div>

      <div>
        <label htmlFor="registerEmail" className="sr-only">Correo Electrónico</label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <UserCircleIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            id="registerEmail"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            placeholder="Correo Electrónico"
            disabled={isBusy}
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={isBusy || !email.trim()}
        className="w-full flex items-center justify-center py-2.5 px-4 rounded-md shadow-sm text-base font-semibold text-white transition-opacity disabled:opacity-60"
        style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
      >
        {isBusy ? <SpinnerIcon className="w-5 h-5 text-white mr-2" /> : null}
        Continuar
      </button>

      <div className="text-center pt-2">
        <p className="text-xs text-gray-600">
          ¿Ya tienes una cuenta?{' '}
          <button
            type="button"
            onClick={onSwitchToSignIn}
            disabled={isBusy}
            className="font-bold text-sky-700 hover:underline focus:outline-none"
          >
            Iniciar Sesión
          </button>
        </p>
      </div>
    </form>
  );
};
